import { LEAVE_CATEGORY_ROUTE_ID, CREATE_LEAVE_CATEGORY_ROUTE_ID } from './common';
import LeaveCategory from './index';
import LeaveCategoryCreateUpdate from './LeaveCategory';

export default {
    [LEAVE_CATEGORY_ROUTE_ID]: () => <LeaveCategory />,
    [CREATE_LEAVE_CATEGORY_ROUTE_ID]: () => <LeaveCategoryCreateUpdate />,
};
